import { FC } from 'react';

import { Button } from '@dynamika-shared/ui/Button/Button';

type ExportCsvButtonProps = {
  onExport: () => void;
  isExporting: boolean;
  disabled?: boolean;
};

export const ExportCsvButton: FC<ExportCsvButtonProps> = ({
  onExport,
  isExporting,
  disabled,
}) => (
  <Button
    type='secondary'
    loading={isExporting}
    disabled={isExporting || disabled}
    onClick={onExport}
    data-testid='exportCsvButton'
  >
    Download as CSV
  </Button>
);
